<script>
import { init } from '@didi/webx-js'
import { genRenderFnForH5 } from '@didi/dpub-render'
import genPageLifeCycleEvents from '../../lib/js/event/general-event-list/lifecycle'
import { initPageExposeTime } from '../../lib/js/event/event-center/event-list/pageExposeTime.js'
import { getUrlParams } from '../../lib/js/utils'

export default {
  name: 'Index',
  data () {
    return {
      backPopupShow: false
    }
  },
  render: function (h) {
    if (__isServerRender__) {
      return genRenderFnForH5(this.page, this.$options.components)(h)
    } else {
      return genRenderFnForH5(this.page, this.compMap)(h)
    }
  },
  computed: {
    page: function () {
      return this.$store.state.page
    },
    compMap () {
      return this.$store.state.compMap
    }
  },
  watch: {
    $route() {
      this.$store.dispatch('setInitData')
    }
  },
  updated () {
    const trackSWWhiteList = [
      '.hot-area', // 图片热区
      '.image-wrapper', // 图片
      '.slide', // 轮播图-由于底层实现原因 监听元素可见判断和用户可见存在误差 所以此处第一帧按组件曝光 其他帧在组件内部监听
      '.video-wrapper', // 视频
      '.page-audio-wrapper', // 背景音乐
      '.countdown-root-view', // 倒计时
      '.marquee-root', // 跑马灯
      '.privacy-agreement-root', //隐私协议
      '.increase-text-root', // 计数器
    ]
    const layersList = []
    // 热区渲染靠后，通过宏任务确保dom获取
    setTimeout(() => {
      trackSWWhiteList.forEach(selector => {
        layersList.push(...document.querySelectorAll(selector))
      })
      const observeList = layersList.filter(el => {
        return this.$store.state.hasTrackLayers.indexOf(el.id) === -1
      })
      this.$store.commit('setObserveCount', observeList.length)
      console.log('layersList', layersList, 'hasTrackLayers', this.$store.state.hasTrackLayers, 'observeList', observeList)
      // observe遍历监听所有box节点
      observeList.forEach(observe => this.$store.state.io.observe(observe))
    }, 0)
  },
  mounted () {

    if (!__isServerRender__) {
      this.init()
    }
  },
  beforeDestroy () {
    this.$store.state.io.disconnect()
  },
  methods: {
    initRouterBackEvt () {
      if (this.$store.state.backPopup && window.history && window.history.pushState) {
        history.pushState(null, null, document.URL)
        window.addEventListener('popstate', this.handleRemainPopup, false)
      }
    },
    handleRemainPopup () {
      if (this.$store.state.backPopup && !this.backPopupShow && this.$route.name === 'index') {
        this.backPopupShow = true
        this.$store.dispatch('setWidgetVisibility', this.$store.state.backPopup)
      } else {
        this.$router.go(-1)
      }
    },
    init () {
      if(this.$store.state.prefetched) {
        init({
          initOption: {
            quitInitProduct: false,
            needLaunchApp: __isServerRender__ ? false : !!getUrlParams().dchn,
            env: process.env.WEBX_ENV,
          }
        })
      }
      this.initRouterBackEvt()
      const pageEvents = genPageLifeCycleEvents(this.page)
      // 埋点
      this.$trackEvent('userteam_ad_zj_loadpage_sw', { effect_style: this.$getPubData('effect_style') })
      // 页面停留时长埋点
      initPageExposeTime()
      this.$nextTick(() => {
        if (!window.__INITIAL_STATE__) {
          // 性能埋点：CSR DOM 渲染完成
          // console.log('===CSR CSR CSR===');
          window.PerfTrack.domReady()
        }
        // 隐藏页面loading
        const loading = document.querySelector('#ut-launch-slp-page-loading')
        if (loading) loading.style.display = 'none'
        const runCustomFooterScript = window.runCustomFooterScript
        if (typeof runCustomFooterScript === 'function') {
          // 调用用户自定义的 js footer
          runCustomFooterScript()
        }
        // 调用页面生命周期事件
        if (pageEvents.mounted && pageEvents.mounted.length) {
          // addInitCbs(function () {
          //   pageEvents.mounted.forEach((event) => {
          //     window.__EVENT_ACTIONS.invoke(event)
          //   })
          // })
          pageEvents.mounted.forEach((event) => {
            window.__EVENT_ACTIONS.invoke(event)
          })
        }
      })
    }
  },
  errorCaptured(err, vm, info) {
    console.log(err, vm, info, 'err')
  },
}
</script>
